const ErrorWrapper = ({error, tailwindClass}) => {
    const errorToShow = (typeof error === 'string' || error instanceof String) ? error : "⚠ Impossible de récupérer les données ⚠";
    
    if (typeof tailwindClass !== 'string') {
        tailwindClass = ""
    }

    const finalClass = "min-h-52 flex items-center justify-center text-xl " + tailwindClass;

    return (
        <div className={finalClass}>
            <p>{errorToShow}</p>
        </div>
    );
}

export default ErrorWrapper;